export default __webpack_public_path__ + "static/media/dumpling.ae59b63c.jpg";